<template>
  <div>
    <AppLayoutHeader :hide-hamburger-button="true" />
    <div class="form-container">
      <Stage :stage="step" />
      <div class="pa-3">
        <template v-if="step === 1">
          <h2 class="--prm text-center">情報入力</h2>
          <v-form ref="promoForm" class="mt-9">
            <vs-promo-code ref="vsPromoCode" v-model="promoCode" :disabled="!!tokenInfo.promoCode" />
          </v-form>
          <v-btn class="text-heading mt-4 mb-12 --w-bold" rounded block color="primary" x-large @click="next">
            {{ $t('buttons.next') }}
          </v-btn>
        </template>
        <template v-else>
          <h2 class="--prm --w-bold text-center">{{ $t('text.stage.confirmation') }}</h2>
          <p class="mt-6 text-title--szm --dark --w-medium">{{ $t('text.register.pleaseConfirmExistingClient') }}</p>
          <div class="bg-smoke mt-8 px-4">
            <v-row class="ma-0">
              <v-col class="pa-0 py-4 text-normal --w-bold --dark">{{ $t('common.awardCode') }}</v-col>
              <v-col class="pa-0 py-4 text-small --w-regular --dark">{{ promoCode || '—' }}</v-col>
            </v-row>
          </div>
          <calculated-fee :promo-code="promoCode" :token="token" @ready="feeReady = true" />
          <vs-signup-confirmation-form ref="confirmation" v-model="confirmationForm" />
          <v-btn class="mt-4" rounded block outlined :disabled="submitting" @click="step = 1">
            情報入力へ戻る
          </v-btn>
          <v-btn
            class="text-heading mt-4 mb-12 --w-bold"
            rounded block color="primary" x-large
            :loading="submitting" :disabled="submitting || !feeReady"
            @click="submit"
          >{{ $t('registerPage.submit') }}</v-btn>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import AppLayoutHeader from '@/layout/AppLayout/components/AppLayoutHeader'
import { VS_SIGNUP_SUBMIT_EXISTING_CLIENT } from '@/api/graphql/user'
import { getVsSignupExceptionKey, vsSignupRoute } from '@/utils/vs-signup-policy'
import { sessionStorageMixin } from '@/mixins/session-storage.mixin'
import commonConstants from '../common.constants'
import VsPromoCode from '../PaymentMethod/VsPromoCode.vue'
import CalculatedFee from '../Confirmation/CalculatedFee.vue'
import VsSignupConfirmationForm from '../Confirmation/VsSignupConfirmationForm.vue'
import Stage from './Stage.vue'

export default {
  components: { AppLayoutHeader, Stage, VsPromoCode, CalculatedFee, VsSignupConfirmationForm },
  mixins: [sessionStorageMixin],
  props: {
    token: { type: String, required: true },
    tokenInfo: { type: Object, required: true }
  },
  data () {
    return {
      step: 1,
      promoCode: this.tokenInfo.promoCode || null,
      confirmationForm: null,
      feeReady: false,
      submitting: false,
      submitted: false
    }
  },
  methods: {
    next () {
      if (this.$refs.vsPromoCode.hasError || !this.$refs.promoForm.validate()) {
        this.$toast.error('特典コードに誤りがあります。')
        return
      }
      this.feeReady = false
      this.step = 2
    },
    async submit () {
      if (this.submitting || this.submitted || !this.feeReady || !this.$refs.confirmation.validate()) return
      const exceptionKey = getVsSignupExceptionKey(this.$route)
      if (!exceptionKey) return
      this.submitting = true
      try {
        await this.$doLoading(async () => {
          await this.$showGqlError(async () => {
            await this.$apollo.mutate({
              mutation: VS_SIGNUP_SUBMIT_EXISTING_CLIENT,
              variables: {
                token: this.token,
                exceptionKey,
                data: {
                  promoCode: this.promoCode || undefined,
                  media: this.confirmationForm.media
                }
              }
            })
            this.submitted = true
            this.removeFromStorage(commonConstants.storageKey)
            await this.$router.replace(vsSignupRoute(this.$route, 'register-existing-complete'))
          })
        })
      } catch (_) {
        // The shared GraphQL handler displays the error and handles revoked URLs.
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>
